import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLang } from "../contexts/LanguageContext";
import { useAuth } from "../contexts/AuthContext";
import { api, formatApiError } from "../lib/api";
import Layout from "../components/Layout";
import PasswordInput from "../components/PasswordInput";

export default function ChangePassword() {
  const { t } = useLang();
  const { user, refresh } = useAuth();
  const nav = useNavigate();
  const [current, setCurrent] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pw !== pw2) return setErr(t.auth.mismatch);
    if (pw.length < 8) return setErr("Min 8 caractères");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: pw });
      await refresh();
      nav(user?.role === "admin" ? "/admin" : "/dashboard");
    } catch (e2) { setErr(formatApiError(e2)); }
    finally { setLoading(false); }
  };

  return (
    <Layout noFooter>
      <section className="min-h-screen flex items-center justify-center px-6 py-32 bg-ivory">
        <div className="w-full max-w-md">
          <h1 className="font-serif text-4xl font-light text-navy leading-tight mb-3">{t.auth.change_title}</h1>
          <p className="text-ink/60 mb-10">{t.auth.change_sub}</p>

          <form onSubmit={submit} data-testid="change-form" className="space-y-7">
            <div>
              <label className="block text-[10px] uppercase tracking-[0.25em] font-mono text-ink/55 mb-2">{t.auth.current_password}</label>
              <PasswordInput data-testid="change-current" required value={current} onChange={(e) => setCurrent(e.target.value)} />
            </div>
            <div>
              <label className="block text-[10px] uppercase tracking-[0.25em] font-mono text-ink/55 mb-2">{t.auth.new_password}</label>
              <PasswordInput data-testid="change-pw" required value={pw} onChange={(e) => setPw(e.target.value)} />
            </div>
            <div>
              <label className="block text-[10px] uppercase tracking-[0.25em] font-mono text-ink/55 mb-2">{t.auth.confirm_password}</label>
              <PasswordInput data-testid="change-pw2" required value={pw2} onChange={(e) => setPw2(e.target.value)} />
            </div>
            {err && <div data-testid="change-error" className="text-sm text-destructive">{err}</div>}
            <button data-testid="change-submit" disabled={loading} type="submit" className="w-full bg-brand hover:bg-brandDark disabled:opacity-60 text-white py-4 text-sm uppercase tracking-[0.18em] font-mono">
              {loading ? "..." : t.auth.change_submit}
            </button>
          </form>
        </div>
      </section>
    </Layout>
  );
}
